export const ONE_DAY = 1000 * 60 * 60 * 24
export const ONE_WEEK = ONE_DAY * 7
